// ABOUTME: POST /companies: staff create a client company from its name and website (the server derives the domain).
// ABOUTME: A 400 (website refused) and a 409 (domain taken) are shown in the form, so only other failures toast.
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { errorHandler, successHandler } from '../../../utils';
import {
  CompanyBuilder,
  CreateCompanyInput,
  CreateCompanyOutput,
} from '../companies.types';

export const createCompany = (builder: CompanyBuilder) =>
  builder.mutation<CreateCompanyOutput, CreateCompanyInput>({
    query: ({ Name, Url }) => ({
      url: '/companies',
      method: 'POST',
      body: { Name, Url },
    }),
    transformResponse: (queryResponse: CreateCompanyOutput, _, arg) => {
      successHandler(
        arg.lang === 'es'
          ? SuccessMessageEs.COMPANY_CREATED
          : SuccessMessageEn.COMPANY_CREATED,
        true
      );
      return queryResponse;
    },
    transformErrorResponse: (error, _, arg) => {
      errorHandler(
        '[createCompany]',
        arg.lang === 'es'
          ? ErrorMessageEs.CreateCompany
          : ErrorMessageEn.CreateCompany,
        error,
        error.status !== 400 && error.status !== 409
      );
      return error.data;
    },
    invalidatesTags: () => [{ type: 'Company' }],
  });
